<template>
    <contentCardMobile :loading="loading" :elevation="0" classCard="px-0 mx-0 py-0" cardColor="transparent">
        <template slot="cardContent">
            <div >
                <v-row justify="space-around">
                    <v-col cols="12" md="5" >
                        <div class="font-weight-bold body-1 courses-m-read-main-container">
                           {{ course.title }}
                            <primary-button :props="startBtnData" class=""></primary-button>  
                        </div>
                    </v-col>
                </v-row>
                 
            
                    

                <v-row justify="space-around">
                    <v-col cols="12" md="5" class="py-0">

                        <div class="text-center" v-if="loading">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                            ></v-progress-circular>
                        </div>

                        

                        <div v-if="!loading && course == null" class="text-center">
                            <span>Sin resultados</span>
                        </div>


                        <div>
                            <CourseItemDetail :course="course" :fixTabs="true">
                            
                            </CourseItemDetail>
                        </div>

                      
                       
                        
                    </v-col>
                </v-row>
            </div>
        </template>
    </contentCardMobile>
    
</template>

<script>
// import Utils from '../../../helpers/Utils';
import CourseItemDetail from '../../managerViews/courses/read/CourseItemDetail.vue';
export default {
    
    components: {
        CourseItemDetail
    },
	data(){
		return {
            loading:true,
            id: this.$route.params.id,
            step: '1',
            course:{
                title: "",
                brief_description:"",
                duration: "",
                summary: "",
                description: "",
                what_you_will_learn: "",
                sections:[
                    // {
                    //     title: '',
                    //     lessons: [
                    //         {
                    //             title:'',
                    //             type: 'LECCIÓN',
                    //             has_content:false,
                    //         }
                    //     ]
                    // }
                ],
                list_companies:[],
                draft:0,
                image_file: [],
                update_image_file: [],
                image_url: "",
                sections_to_delete: [],
                lessons_to_delete: [],

                images_data:[
                    // {id, url}
                ]
                // _method: "POST",
            },
            startBtnData: {
                text: "Comenzar",
                icon: "",	
                click: () => {this.startCourse(this.id)},
                block:false,
                loading: false,
            },
		}
    },
    watch: {
        
     
      
    },
    mounted(){
        this.index();
    },
	methods: {
        

        index(){
            
            this.loading = true;
            this.$api.employeeCourses.getCourse(this.id)
				.then((response) =>{
                    this.course.title = response.data.title;
                    this.course.brief_description = response.data.brief_description;
                    this.course.duration = response.data.duration;
                    this.course.summary = response.data.summary;
                    this.course.description = response.data.description;
                    this.course.what_you_will_learn = response.data.what_you_will_learn;
                    this.course.sections =response.data.sections;
                    this.course.list_companies = response.data.companies.map((x) => {
                        return {text: x.name, value: x.id}
                    });
                    this.course.draft = response.data.draft == true ? 1 : 0;
                    this.course.image_file = [];
                    this.course.image_url = response.data?.image?.url??'';

                    for (let i = 0; i < this.course.sections.length; i++) {
                        this.course.sections[i]
                        for (let index = 0; index < this.course.sections[i].lessons.length; index++) {
                            this.course.sections[i].lessons[index].type = this.course.sections[i].lessons[index].content_type;
                            
                        }
                        
                    }

					
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.loading = false;
				})
			;

          
        },

        startCourse(id){
            console.log(id)
            this.$router.push({ name: 'EmployeeCoursesProgress', params: { id: id }}).catch(()=>{});
            
        },

       
    },
}
</script>

<style lang="scss"> 
   
    .courses-m-read{

        &-main-container{
            display: flex;
            justify-content: space-between;
        }
    }
</style>